import _ from "underscore";
import hosButtonsTemplate from "./statusButtonDisplay.HOS.tmpl";
import ewdButtonsTemplate from "./statusButtonDisplay.EWD.tmpl";
import type { THosStatus } from "hos-tools";

export interface StatusButtonDisplayOptions{
    mode: "EWD" | "HOS";
    activeStatusCss: {[ status: string ]: string};
    disabledButtons: boolean;
    isSleeperBerthDisabled: boolean;
    isDriversSeatUser: boolean | null;
    hasNoVehicle: boolean;
    status: THosStatus | undefined;
    translatedLabels?: {
        off: string;
        sb: string;
        d: string;
        on: string;
    };
}

export default class StatusButtonDisplay {
    getDisplay(options: StatusButtonDisplayOptions){
        if (options.mode === "HOS"){
            return _.template(hosButtonsTemplate)({
                activeStatusCss: options.activeStatusCss,
                disabledButtons: options.disabledButtons,
                isSleeperBerthDisabled: options.isSleeperBerthDisabled,
                isDriversSeatUser: options.isDriversSeatUser,
                hasNoVehicle: options.hasNoVehicle,
                status: options.status,
                translatedLabels: options.translatedLabels || { off: "OFF", sb: "SB", d: "D", on: "ON" }
            });
        }

        // ewd
        return _.template(ewdButtonsTemplate)({
            activeStatusCss: options.activeStatusCss,
            disabledButtons: options.disabledButtons,
            status: options.status
        });
    }
}